@if (item.navCap) {
  @if (item.divider) {
    <span class="sidebar-divider"></span>
  }
  <div mat-subheader class="nav-caption">
    <i class="iconify icon-18 caption-icon" data-icon="solar:menu-dots-linear"></i>
    <span class="caption-text">{{ item.navCap }}</span>
  </div>
}
@if (!item.navCap && !item.external && !item.twoLines) {
  <a
    mat-list-item
    (click)="onItemSelected(item)"
    [ngClass]="{
      'mat-toolbar bg-primary activeMenu': item.route ? router.isActive(item.route, true) : false,
      expanded: expanded,
      disabled: item.disabled
    }"
    class="menu-list-item full-width-menu-item"
  >
    @if (item.subItemIcon) {
      <span class="iconify routeIcon sub-item-icon" matListItemIcon [attr.data-icon]="item.iconName"></span>
    } @else {
      <span class="iconify routeIcon" matListItemIcon [attr.data-icon]="item.iconName"></span>
    }

    <span class="hide-menu multi-line-text">{{ item.displayName | translate }}</span>
    @if (item.children && item.children.length) {
      <span class="arrow-icon" fxFlex>
        <span fxFlex></span>
        <mat-icon [@indicatorRotate]="expanded ? 'expanded' : 'collapsed'"> expand_more </mat-icon>
      </span>
    }
    @if (item.chip) {
      <span>
        <span class="{{ item.chipClass }} p-x-8 p-y-4 item-chip f-w-500 rounded-pill ">{{ item.chipContent }}</span>
      </span>
    }
  </a>
}

<!-- external Link -->

@if (!item.navCap && item.external) {
  <mat-list-item onClick="window.open('//google.com')" class="menu-list-item" target="_blank">
    <span class="iconify routeIcon" matListItemIcon [attr.data-icon]="item.iconName"></span>
    <!-- <i-tabler
    class="routeIcon"
    name="{{ item.iconName }}"
    matListItemIcon
  ></i-tabler> -->
    <span class="hide-menu">{{ item.displayName | translate }}</span>
  </mat-list-item>
}

<!-- children -->
@if (expanded) {
  @for (child of item.children; track child) {
    <app-nav-item [item]="child" (click)="onSubItemSelected(child)" [depth]="depth + 1"> </app-nav-item>
  }
}

<style>
  /* Estilos para menú con ancho completo y texto en múltiples líneas */
  .full-width-menu-item {
    width: 100% !important;
    box-sizing: border-box !important;

    /* Sobrescribir estilos de Material que limitan el ancho */
    ::ng-deep .mat-mdc-list-item-content {
      width: 100% !important;
      display: flex !important;
      flex-wrap: wrap !important;
    }
  }

  

  /* Permitir que el texto se muestre en múltiples líneas */
  .multi-line-text {
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: clip !important;
    word-wrap: break-word !important;
    line-height: 1.4 !important;
    /* Asegura que el texto tenga suficiente espacio vertical */
    padding: 2px 0 !important;
  }

  /* Ajustar el ícono para alinearlo con la primera línea de texto */
  .routeIcon {
    align-self: flex-start !important;
    margin-top: 2px !important;
  }

  /* Mejorar el espaciado entre elementos */
  .menu-list-item {
    height: auto !important;
    min-height: 48px !important;
    padding: 2px 0 !important;
  }
</style>
